import { IMediaItem } from './newbuilding/media';
import { IVideo } from './video';

export enum IGallerySections {
  Architecture = 'architecture',
  Parking = 'parking',
  Videos = 'Video',
}

export interface IGalleryMediaItem {
  type: IGallerySections;
  id: string;
  title: string;
  media: IMediaItem[];
}

export interface IGalleryVideoItem {
  type: IGallerySections;
  id: string;
  title: string;
  media: IVideo[];
}

export interface IFullscreenSlide {
  node: React.ReactNode;
  thumbnailNode: React.ReactNode;
}

export type IGallery = Array<IGalleryMediaItem | IGalleryVideoItem>;
